
import { catchError, tap } from 'rxjs/operators';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoggingService } from './logging.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '@environments/environment';

@Injectable()
export class HttpLoggingInterceptor implements HttpInterceptor {

    constructor(private logging: LoggingService, private oidc: OidcSecurityService) { }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        try {
            this.logging.log.sinks['http'].info(req.method, req.url, req.params.toString(), req.body);

            return next.handle(req).pipe(
                catchError(error => {
                    if (this.failedInvalidApiToken(req.url, error)) {
                        this.oidc.logoff('dashboard-ui');
                    }
                    throw error;
                }),
                tap(evt => {
                if (evt instanceof HttpResponse) {
                    this.logging.log.sinks['http'].info(evt.status.toString(), evt.url, evt.body);
                }
            }));
        } catch (error) {
            this.logging.log.sinks['http'].error(req.method, req.url, req.params.toString(), req.body, error);
        }
    }

    /**
     * Checks if the error is caused by an invalid api token(not because of missing token), and if that was related to
     * an api request to the IVD backend. We don't want to handle 401 on websockets or other api calls.
     *
     * @param url Url of the request that failed.
     * @param error related error.
     * @private
     */
    private failedInvalidApiToken(url: string, error: unknown) {
        return error instanceof HttpErrorResponse
            && error.status === 401
            && this.isApiException(url)
            && sessionStorage.getItem('auth_token') !== null;
    }

    private isApiException(url: string) {
        const dashboardBaseUrl = environment.dashboardApi?.baseUrl ?? undefined;
        const apiBaseUrl = environment.api?.baseUrl ?? undefined;
        return (!!dashboardBaseUrl && url.startsWith(dashboardBaseUrl)) || (!!apiBaseUrl && url.startsWith(apiBaseUrl));
    }
}
